import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableStyles from 'consts/styles/Tablev2';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const tableStyles = makeStyles(theme => ({
  CustomizedTable: {
    width: '100%',
    '&__container': {
      overflowX: 'initial',
      position: 'relative',
      width: '100%',
      '&__table': {
        border: '2px solid',
        borderBottom: 'none',
        borderColor: theme.palette.blackAlfa,
        borderRadius: '5px',
        '&__body': {
          '&__row': {
            '&__cell': {
              '&--dashboard': {
                color: `${theme.palette.secondary.main} !important`,
              },
              '&--active': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:nth-child(0)': {
                  justifyContent: 'flex-start',
                },
                '&--true': {
                  color: theme.palette.success.main,
                },
                '&--false': {
                  color: theme.palette.error.main,
                },
              },
              '&--status': {
                border: '1px solid',
                borderRadius: 15,
                padding: '1px 5px',
              },
            },
            '&--active': {
              backgroundColor: 'rgba(14, 165, 233, 0.06)',
              borderLeft: '3px solid #06B6D4',
              transition: 'background-color 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(14, 165, 233, 0.12) !important',
              },
            },
          },
        },
        '&__sort': {
          '&:hover': {
            color: theme.palette.white,
          },
          '&--active': {
            color: '#06B6D4 !important',
          },
          '&__visually-hidden': {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
          },
        },
      },
      '&__pagination': {
        width: '100%',
        color: theme.palette.white,
        padding: '0 15px 0 0',
        backgroundColor: theme.palette.blackAlfa,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '0px 0px 5px 5px',
        maxHeight: 35,
        '&--white-space': {
          padding: '0 25px',
          width: 25,
          height: 25,
        },
      },
    },
    '&--small-table': {
      maxHeight: 100,
      overflowX: 'hidden',
      overflowY: 'auto',
    },
  },
  NoData: {
    paddingLeft: 20,
  },
}));

const cellStyles = theme => ({
  head: {
    color: '#F8FAFC',
    backgroundColor: '#0f1923',
    borderBottom: '2px solid rgba(14, 165, 233, 0.2)',
    padding: '6px 10px',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    position: 'sticky', 
    top: 0,              
    zIndex: 1,           
  },
  body: {
    padding: TableStyles.tableSmall.cell.padding,
  },
});

const StyledTableCell = withStyles(theme => cellStyles(theme))(TableCell);

const StyledTableRow = withStyles({
  root: {
    cursor: 'pointer',
    padding: '0 15px',
  },
})(TableRow);

export { tableStyles, StyledTableCell, StyledTableRow };